import styled from 'styled-components';

export default styled.div`
  float: right;

  > div {
    margin: 0;
    padding: 0;
  }
`;
